import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import enion from '../svg/enion-logo-dark-bg.svg'

export function Logo(): React.ReactElement {
  const navigate = useNavigate()

  return (
    <Box onClick={() => navigate('/')}>
      <img style={{ height: '1.5rem', display: 'block', margin: '0 auto', userSelect: 'none' }} src={enion} alt="Enion logo"/>
    </Box>
  )
}
